import React, { useEffect, useState } from 'react';
import { Pie } from 'react-chartjs-2';
import { Chart, ArcElement, Tooltip, Legend } from 'chart.js';

Chart.register(ArcElement, Tooltip, Legend);

const PetTypes = () => {
  const [data, setData] = useState(null);
  const [selectedTrait, setSelectedTrait] = useState('Terrain');
  const [totalCount, setTotalCount] = useState(0);

 // When component loads
useEffect(() => {
    fetch('https://api.pixelore.wiki/api/pet-data')
      .then((response) => response.json())
      .then((data) => {
        setData(data);
        setTotalCount(data.count);
      })
      .catch((error) => console.error('Error fetching Pixel Pets:', error));
  }, []);  

  if (!data) return <div>Loading...</div>;

  const traitOptions = Object.keys(data.stringtraits);

  const chartData = {
    labels: Object.keys(data.stringtraits[selectedTrait]),
    datasets: [
      {
        label: selectedTrait,
        data: Object.values(data.stringtraits[selectedTrait]),
        backgroundColor: [
          '#FF6384', '#36A2EB', '#FFCE56', '#8AE234', '#AD7FA8',
          '#FCB150', '#6495ED', '#FFA07A', '#40E0D0', '#DDA0DD',
          '#FF69B4', '#7FFFD4', '#B0E0E6', '#FFD700', '#CD5C5C'
        ],
        borderWidth: 1,
      },
    ],
  };

  return (
    <div className="wiki-text">
    <div style={{ width: '300px', margin: 'auto' }}>
      <div>Total Pets: {totalCount}</div>

      <select value={selectedTrait} onChange={(e) => setSelectedTrait(e.target.value)}>
        {traitOptions.map(trait => (
          <option key={trait} value={trait}>{trait}</option>
        ))}
      </select>

      <Pie data={chartData} />
    </div></div>
  );
};

export default PetTypes;
